import { useDispatch } from 'react-redux';
import I18n from 'i18n-js';
import { func } from 'prop-types';

import { setNotificationsEnabled } from '@lootboy/lib/actions/DailyBoostActions';

import BottomPopupButton, { SIDES } from '~/components/BottomPopupButton';

import style from './Footer.module.scss';

export default function Footer({ toggleShow }) {
  const dispatch = useDispatch();

  const confirm = () => {
    dispatch(setNotificationsEnabled());
    toggleShow();
  };

  return (
    <div className={style.footer}>
      <BottomPopupButton
        side={SIDES.LEFT}
        onClick={toggleShow}
      >
        {I18n.t('common_no_thanks')}
      </BottomPopupButton>
      <BottomPopupButton
        side={SIDES.RIGHT}
        divider
        onClick={confirm}
      >
        {I18n.t('common_yes')}
      </BottomPopupButton>
    </div>
  );
}

Footer.propTypes = {
  toggleShow: func.isRequired,
};
